import { Card, Tabs, type TabsProps, theme, Typography } from 'antd'
import { EditChannelModal, useChannels } from '@entities/channel'
import useMobileView from '@shared/hooks/isMobile'
import React, { useMemo, useState } from 'react'
import { usePosts } from '@entities/post'
import { EmployeeChannelRole, InternetRecourceType } from '@entities/channel/model/types'
import { AdvertisingSlots } from '@pages/stock/ui/AdvertisingSlots'
import { TopSideHeader } from '@widgets/top-side-header'
import { Statistics } from '@pages/stock/ui/Statistics'
import { Seller } from '@pages/stock/ui/Seller'
import { Finance } from '@pages/stock/ui/Finance'

export const Stock = () => {
    const [isEditChannelModalOpen, setIsEditChannelModalOpen] = useState(false)
    const isMobile = useMobileView()

    const { channelDetails } = useChannels()

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: <span style={{ fontSize: '17px' }}>Рекламные слоты(Биржа каналов)</span>,
            children: (
                // <div style={{ maxHeight: !isMobile ? 'calc(100vh - 540px)' : undefined, overflow: 'auto' }}>
                <div>
                    <AdvertisingSlots />
                </div>
            )
        },
        {
            key: '2',
            label: <span style={{ fontSize: '17px' }}>Статистика и описание</span>,
            disabled: channelDetails?.role !== EmployeeChannelRole.owner,
            children: (
                <div>
                    {/*<div style={{ maxHeight: !isMobile ? 'calc(100vh - 540px)' : undefined, overflow: 'auto' }}>*/}
                    <Statistics />
                </div>
            )
        },
        {
            key: '3',
            label: <span style={{ fontSize: '17px' }}>Продавец</span>,
            disabled: channelDetails?.role !== EmployeeChannelRole.owner,
            children: (
                <div>
                    <Seller />
                </div>
            )
        },
        {
            key: '4',
            label: <span style={{ fontSize: '17px' }}>Финансы</span>,
            disabled: channelDetails?.role !== EmployeeChannelRole.owner,
            children: (
                <div>
                    <Finance />
                </div>
            )
        }
    ]

    return (
        <Card bodyStyle={{ padding: isMobile ? '14px' : 'auto' }}>
            <TopSideHeader title={'Продать рекламу'} />

            {/* Меню закладок */}
            <Tabs defaultActiveKey="1" items={items} onChange={() => { }} />

            {channelDetails && isEditChannelModalOpen && (
                <EditChannelModal
                    channel={channelDetails}
                    open={isEditChannelModalOpen}
                    onClose={() => setIsEditChannelModalOpen(false)}
                />
            )}
        </Card>
    )
}
